module.exports = __webpack_public_path__ + "img/7_uk.f496f7b0.svg";